export type ChartType = "bar" | "line" | "area" | "pie" | "kpi";
export type FilterOp = "eq" | "neq" | "in" | "gte" | "lte";
export type TimePreset = "last_7d" | "last_30d" | "last_90d" | "last_12m" | "all";

export interface WidgetFilter { field: string; op: FilterOp; value: unknown; }
export interface TimeRange { field?: string; preset?: TimePreset; start?: string; end?: string; }

export interface WidgetSpec {
  metric: string;
  chart_type: ChartType;
  dimensions: string[];
  filters: WidgetFilter[];
  time_range: TimeRange;
  options: Record<string, unknown>;
}

export interface SeriesPoint { label: string; value: number; }
export interface QueryResponse { series: SeriesPoint[]; meta: Record<string, unknown>; }

export interface MetricDefinition {
  key: string; label: string; description: string; entity: string;
  aggregation: "count" | "sum" | "avg";
  allowed_dimensions: string[]; allowed_filters: string[];
  default_chart_types: ChartType[]; formatting: Record<string, unknown>;
}
export interface CatalogResponse { metrics: MetricDefinition[]; dimensions: Record<string, string>; }

export type AccessLevel = "owner" | "edit" | "view";
export interface WidgetResponse { id: string; dashboard_id: string; title: string; spec: WidgetSpec; }
export interface DashboardResponse {
  id: string; name: string; description: string | null;
  layout: Array<{ i: string; x: number; y: number; w: number; h: number }>;
  is_default: boolean; owner_user_id: string; access_level: AccessLevel;
  widgets: WidgetResponse[];
}
export interface GrantResponse { id: string; grantee_type: "role" | "user"; grantee_id: string; access_level: "view" | "edit"; }

export const DEFAULT_SPEC = (metric: string): WidgetSpec => ({
  metric, chart_type: "bar", dimensions: [], filters: [],
  time_range: { preset: "last_90d", field: "invoice_date" }, options: {},
});
